/* eslint-disable react/no-danger */
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Modal, Header, Button, Segment } from 'semantic-ui-react';

class ConfirmBox extends PureComponent {
  static propTypes = {
    header: PropTypes.string,
    content: PropTypes.any,
    buttonText: PropTypes.string,
    action: PropTypes.func,
    propagateClosure: PropTypes.func,
    type: PropTypes.string,
    open: PropTypes.bool,
  }

  static defaultProps = {
    header: 'Demande de confirmation',
    content: '',
    buttonText: 'Confirmer',
    action: () => null,
    propagateClosure: () => null,
    type: null,
    open: false,
  }

  constructor(props) {
    super(props);
    this.state = {
      open: props.open,
    };
  }

  componentDidMount() {
    document.addEventListener('keydown', this.handleEscape, false);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.open && !this.state.open) {
      this.setState({ open: true });
    }
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.handleEscape, false);
  }

  handleEscape = (e) => {
    if (e.keyCode === 27 && this.state.open) {
      this.handleClose();
    }
  }

  handleClose = () => {
    this.props.propagateClosure();
    this.setState({ open: false });
  }

  render() {
    let icon;
    let negativity = false;
    switch (this.props.type) {
      case 'destructive':
        icon = 'red remove circle';
        negativity = true;
        break;
      case 'neutral':
        icon = 'blue help circle';
        break;
      case 'create':
        icon = 'green add square';
        break;
      case 'success':
        icon = 'green circular checkmark';
        break;
      case 'warn':
        icon = 'yellow warning sign';
        break;
      default:
        icon = 'blue info circle';
    }

    return (
      <Modal
        open={this.state.open}
        // basic
        // dimmer="blurring"
        size="tiny"
      >
        <Header icon={{ className: icon }} content={this.props.header} />
        <Modal.Content>
          <Segment basic textAlign="center">
            {typeof this.props.content === 'string'
              ? (
                <p dangerouslySetInnerHTML={{ __html: this.props.content }} />
              ) : this.props.content}
          </Segment>
        </Modal.Content>
        <Modal.Actions>
          <Button onClick={this.handleClose}>
            Annuler
          </Button>
          <Button
            autoFocus
            color="blue"
            primary
            negative={negativity}
            onClick={() => {
              this.handleClose();
              this.props.action();
            }}
          >
            {this.props.buttonText}
          </Button>
        </Modal.Actions>
      </Modal>
    );
  }
}

export default ConfirmBox;



// WEBPACK FOOTER //
// ./src/components/Modals/ConfirmBox.js